"use client";
import React from "react";
import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import {
	BuyTicketsSteps,
	checkoutPayload,
	isContactFormValid,
	isLoading,
	isPaymentTimedOut,
	navigateToStep,
	patchProfileTicketOrderValues,
	profileForTicketOrder,
	submitPayment,
	setIsTimeoutPayment,
} from "@/app/events/[id]/store/buy-tickets.store";
import { useSignals } from "@preact/signals-react/runtime";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { StepList } from "./StepList";
import { Loader } from "@/components/ui/loader";
import CountdownTimer from "./Timer";

export const CheckoutForm = () => {
	useSignals();

	const checkoutPayloadData = checkoutPayload.value;
	console.log('checkoutPayloadData', checkoutPayloadData);

	return <>{checkoutPayloadData?.clientSecret && <PaymentElement />}</>;
};

export const CheckoutFormWithElement = () => {
	const stripe = useStripe();
	const elements = useElements();
	console.log('elements', elements);
	console.log('stripe', stripe);

	useSignals();

	const profile = profileForTicketOrder.value;
	return (
		<>
			<form
				className="overflow-y-hidden flex flex-col"
				onSubmit={async (event) => {
					event.preventDefault();
					await submitPayment(elements, stripe);
				}}
			>
				<CardContent className="grow overflow-y-auto pb-0">
					<div className="pt-6 mb-6">
						<StepList />
					</div>
					<Card className="mb-6 bg-navy-blue/5 border-purple-200">
						<CardHeader>
							<CardTitle className="text-xl font-medium text-midnight-teal">
								Personal Information
							</CardTitle>
						</CardHeader>
						<CardContent>
							<form className="grid gap-4 sm:grid-cols-2">
								<div className="flex flex-col">
									<Label
										className="mb-2 text-gray-600 font-normal"
										htmlFor="firstName"
									>
										First name <span className="text-red-500">*</span>
									</Label>
									<Input
										id="firstName"
										placeholder="Enter first name"
										value={profile?.firstName}
										onChange={(e) => patchProfileTicketOrderValues({ firstName: e.target.value })}
										required
									/>
								</div>
								<div className="flex flex-col">
									<Label
										className="mb-2 text-gray-600 font-normal"
										htmlFor="lastName"
									>
										Last name <span className="text-red-500">*</span>
									</Label>
									<Input
										id="lastName"
										placeholder="Enter last name"
										value={profile?.lastName}
										onChange={(e) => patchProfileTicketOrderValues({ lastName: e.target.value })}
										required
									/>
								</div>
								<div className="flex flex-col">
									<Label
										className="mb-2 text-gray-600 font-normal"
										htmlFor="email"
									>
										Email address <span className="text-red-500">*</span>
									</Label>
									<Input
										value={profile?.email}
										id="email"
										type="email"
										placeholder="j.wayne@gmail.com"
										readOnly={true}
									/>
								</div>
								<div className="flex flex-col">
									<Label
										className="mb-2 text-gray-600 font-normal"
										htmlFor="phone"
									>
										Phone number <span className="text-red-500">*</span>
									</Label>
									<Input
										id="phone"
										type="tel"
										value={profile?.contactNumber}
										onChange={(e) =>
											patchProfileTicketOrderValues({ contactNumber: e.target.value })
										}
										required
									/>
								</div>
							</form>
						</CardContent>
					</Card>
					<Card className="mb-6 bg-navy-blue/5 border-purple-200">
						<CardHeader>
							<CardTitle className="text-xl font-medium text-midnight-teal">
								Payment Information
							</CardTitle>
						</CardHeader>
						<CardContent>
							<CheckoutForm />
						</CardContent>
					</Card>
				</CardContent>
				<CardFooter className="justify-between gap-2 pt-6 border-t absolute bottom-0 md:static bg-white w-full md:w-auto">
					<CountdownTimer
						ttl={300}
						onIsRunningChange={setIsTimeoutPayment}
					/>
					<div className="flex justify-between gap-4">
						<Button
							variant="outline"
							onClick={() => navigateToStep(BuyTicketsSteps.SelectTicket)}
						>
							Back
						</Button>
						<Button
							className="bg-navy-blue hover:bg-navy-blue/85"
							disabled={!isContactFormValid.value || isLoading.value || isPaymentTimedOut.value}
							onClick={async () => {
							//selectTicketPageContinue()
							}}
						>
							{isLoading.value ? <Loader /> : null}
							Pay Now
						</Button>
					</div>
				</CardFooter>
			</form>
		</>
	);
};
